/**
 * 由 CoCo 源代码计划解包器解包
 *
 * 模块 ID：817__part-1
 */

"use strict"

var i
var r
import * as /* [auto-meaningful-name] */Module_38 from /* 38 */"../38"
!function (e) {
  e.Ok = "ok"
  e.Exited = "exited"
  e.Crashed = "crashed"
  e.Abnormal = "abnormal"
}(r || (r = {}));
(function (e) {
  e.Ok = "ok"
  e.Errored = "errored"
  e.Crashed = "crashed"
})(i || (i = {}))
export { r }
